export const ru = {
  header: {
    title: 'Игра Линии',
    language: 'Язык',
    theme: 'Тема',
  },
  game: {
    score: 'Счет',
    max: 'Макс',
    nextBalls: 'Следующие шары',
    resetGame: 'Новая игра',
    help: 'Помощь',
  },
  resetConfirm: {
    title: 'Новая игра',
    message: 'Вы уверены, что хотите начать новую игру? Ваш прогресс будет потерян.',
    confirm: 'Сбросить',
    cancel: 'Отмена',
  },
  gameOver: {
    title: 'Игра окончена',
    yourScore: 'Ваш счет',
    playAgain: 'Играть снова',
    lowScore: 'Хорошая попытка! Попробуйте еще раз, чтобы улучшить свой результат.',
    mediumScore: 'Отличная работа! Вы становитесь лучше!',
    highScore: 'Отличный результат! Вы действительно хороши в этом!',
    excellentScore: 'Удивительно! Вы мастер игры Линии!',
  },
  helpDialog: {
    title: 'Как играть',
    rules: 'Правила игры',
    scoring: 'Подсчет очков',
    tips: 'Советы',
    gotIt: 'Понятно!',
    rulesItems: [
      'Игра происходит на сетке 9×9, на которой появляются цветные шары.',
      'Каждый ход, 3 новых шара случайных цветов добавляются на доску.',
      'Выберите шар и кликните на пустую ячейку, чтобы переместить его.',
      'Шары могут двигаться только если есть свободный путь (без других шаров на пути).',
      'Сформируйте линии из 5 или более шаров одного цвета (по горизонтали, вертикали или по диагонали).',
      'Когда линии формируются, шары исчезают, и вы зарабатываете очки.',
      'Игра заканчивается, когда доска заполнена шарами, и больше нет возможных ходов.',
    ],
    scoringItems: [
      '5 шаров в линию: 10 очков',
      '6 шаров в линию: 12 очков',
      '7 шаров в линию: 18 очков',
      '8 шаров в линию: 28 очков',
      '9 шаров в линию: 42 очка',
    ],
    tipsItems: [
      'Планируйте свои ходы тщательно, чтобы избежать быстрого заполнения доски.',
      'Старайтесь создавать несколько линий одновременно для большего количества очков.',
      'Следите за следующими 3 шарами, которые появятся.',
    ],
  },
  settingsDialog: {
    title: 'Настройки',
    theme: 'Тема',
    selectLanguage: 'Выбрать язык',
    ballAnimation: 'Движение шара',
    ballAnimationStepByStep: 'По шагам',
    ballAnimationShowPath: 'Показать путь и переместить',
    ballAnimationInstant: 'Мгновенное перемещение',
    close: 'Закрыть',
  },
  consentDialog: {
    title: 'Согласие на аналитику',
    description1:
      'Мы используем Google Analytics для улучшения вашего игрового опыта и понимания того, как используется наша игра. Это помогает нам принимать лучшие решения о функциях и улучшениях.',
    description2:
      'Мы собираем анонимные данные об использовании игры, такие как очки, настройки темы и события в игре. Все данные анонимизированы, и мы не собираем никакой лично идентифицируемой информации.',
    description3:
      'Вы можете отклонить сбор аналитики, и ваш выбор будет сохранен. Игра будет работать идеально в любом случае.',
    accept: 'Принять',
    decline: 'Отклонить',
  },
  footer: {
    description: 'Игра "Линии" - Выстроите 5 или более шаров одного цвета в линию',
    email: 'support@lines98.fun',
    contactUs: 'Связаться с нами',
  },
  seo: {
    title: 'Линии - Бесплатная онлайн головоломка с цветными шарами',
    description:
      'Играйте в Линии - бесплатная онлайн головоломка. Перемещайте цветные шары на поле 9x9, собирайте линии из 5 и более шаров и набирайте очки.',
    ogTitle: 'Линии - Головоломка с цветными шарами',
  },
};
